export default __webpack_public_path__ + "static/media/gam.4660ac89.png";